import { AttachFile, DeleteForever, QueuePlayNext } from '@mui/icons-material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import RemoveIcon from '@mui/icons-material/Delete';
import { Avatar, Button, CircularProgress, Container, CssBaseline, Grid, IconButton, ImageList, Switch, TextField, Tooltip, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { FormattedMessage, injectIntl } from 'react-intl';
import ReactQuill from "react-quill";
import { connect } from 'react-redux';
import AddCommonPlaceholder, { PlaceType } from 'src/components/emailConfig/AddCommonPlaceholder';
import DialogGeneral from 'src/components/dialog-general';
import Api2Talk from 'src/services/api2talk';
import Footer from '../../components/footer';
import HeaderMenu from '../../components/header-menu';
import CustomizedSnackbars from '../../components/material-snackbars';
import Title from '../../components/title-name';
import { browserHistory } from '../../helpers/history';
import * as QuickResponseService from "../../services/2talk/quick-response.service.js";
import Api from '../../services/api';
import { getFileDownloadLink } from '../../services/attachment.service';
import { Overlay } from '../../styles/global';
import { Styles } from '../../styles/material-styles';

class QuickResponseEdit extends Component {

  constructor(props) {
    super(props);

    const { userSession, quickresponses } = this.props;
    this.globalAdm = false;
    this.isClient = true;
    if (userSession == null || userSession.user == null || userSession.user.userrole == null) {
      Api.logoff();
    }

    this.initialState = {
      id: quickresponses.quickresponse?.id,
      title: quickresponses.quickresponse?.title,
      content: '',
      ismessagehighlight: false,
    };
    
    this.state = {
      item: this.initialState,
      files: [],
      quickResponseAttachments: [],
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      DialogRemoveState: false,
      attachmentRemoveId: null
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.changeValues = this.changeValues.bind(this);
    this.getFile = this.getFile.bind(this);
    this.removeLogo = this.removeLogo.bind(this);
    this.handleDeleteAttachment = this.handleDeleteAttachment.bind(this);
    this.openOrCloseRemoveModal = this.openOrCloseRemoveModal.bind(this);
    this.validateImagesAtachments = this.validateImagesAtachments.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state === "reload") {
      this.componentDidMount();
    }
  }

  async componentDidMount() {
    await this.getData()
  };


  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [name]: value
      }
    }));
  };

  handleChangeSwitch(event) {
    const stateName = event.target.name;
    const value = event.target.checked;
    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [stateName]: value
      }
    }));
  }

  getData = async () => {

    const intl = this.props.intl;
    this.setState({ loading: true });

    Api2Talk.get(`/quickresponses/${this.state.item.id}`)
      .then(result => {
        if (result.data.success) {
          this.setState({
            loading: false,
            item: {
              ...this.state.item,
              content: result.data.data?.content ?? "",
              ismessagehighlight: result.data.data?.ismessagehighlight ?? false,
            },
            quickResponseAttachments: result.data.data?.attachments ?? []
          });
        }
        else {   
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
          Api.kickoff(result);
        }
      })
      .catch(err => {
        if (err.response && err.response.data && err.response.data.errors) {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
        }
        else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: err.response && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
        }
      });
  };

  handleSubmit = async e => {
    e.preventDefault();

    this.setState({ loading: true });

    let data = {...this.state.item}

    let payload = new FormData();

    for (let key in data) {
      payload.append(key, data[key]);
    }

    let files = this.state.files ?? [];

    if (files?.length > 3) {
      files = files.slice(0, 3);
    }

    files.forEach((file) => payload.append(`FilesUpload`, file));

    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }; 

    Api2Talk.put('/quickresponses', payload, config)

      .then(result => {
        if (result.data.success) {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: intl.formatMessage({ id: "edit.success" })
          });


        }
        else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })

          });
          Api.kickoff(result);

        }
      })
      .catch(err => {
        if (err.response && err.response.data && err.response.data.errors) {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
        }
        else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: err.response && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })

          });
        }
      });
  };

  closeNotification() {
    this.setState({ openNotification: false });
  }

  changeValues(stateName, value, text = '') {
    this.setState({ loading: true });

    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [stateName]: value
      }
    }));
    this.setState({ loading: false });

  };

  handleChangeEditor(value, name) {
    this.setState(prevState => ({
        item: {
            ...prevState.item,
            [name]: value || ""
        }
    }));
  }

  /* INÍCIO ANEXOS */

  getFile = async (attachment) => {
		const intl = this.props.intl;
		this.setState({ loading: true });
		
		let url = await getFileDownloadLink(attachment.attachmentid);
		if(url &&  url.data && url.data.data && url.data.success){
      this.setState({ loading: false });
			window.open(`${url.data.data}`, '_blank');
		} else{
			this.setState({
				loading: false,
        openNotification: true,
        notificationVariant: "error",
				notificationMessage: intl.formatMessage({ id: "file.not.found" })
			});
    }
  }

  validateImagesAtachments = (files) => {
    const intl = this.props.intl;

    if((files.length + this.state?.quickResponseAttachments?.length) > 3) {
      this.setState({
        files: [],
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({id:"checklist.modal.select.image.error"}),
      })
      return
    }

    for (const file of files) {
      if (!file.type.includes("image")) {
        this.setState({
          files: [],
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: intl.formatMessage({id:"checklist.modal.image.field.error"}),
        })
        return
      }
    }

    this.setState({
      files: files
    })
  }

  removeItem(file) {
    let array = [...this.state.files];
    let index = array.indexOf(file)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ files: array });
    }
  }

  async removeLogo(attachmentId) {
    this.setState({ DialogRemoveState: true, attachmentRemoveId: attachmentId })
  }

  openOrCloseRemoveModal = () => {
    this.setState({ DialogRemoveState: false, attachmentRemoveId: null })
  }

  removeItem(file) {
    let array = [...this.state.files];
    let index = array.indexOf(file)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ files: array });
    }
  }

  async handleDeleteAttachment(){
    try {
      const attachmentId = this?.state?.attachmentRemoveId;
      if (attachmentId) {
        await QuickResponseService.removeAttachment(attachmentId);
        this.openOrCloseRemoveModal();
        this.setState(prev => ({
          ...prev,
          quickResponseAttachments: [...prev.quickResponseAttachments.filter(file => file.attachmentid !== attachmentId)]
        }))
      } else {
        this.openOrCloseRemoveModal();
      }
      
    } catch (error) {
      this.setState({
        attachmentRemoveId: null,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: "Não foi possível remover o anexo.",
      })
    }
  }
  
  useStyles = () => {
    return withStyles({
        ImageList: {
            width: "100%",
            height: 100,
        },
    });
  }
  /* FIM ANEXOS */

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const { item } = this.state;
    const intl = this.props.intl;

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    const classes2 = this.useStyles();

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container component='main' maxWidth='md'>
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                  <Button variant='outlined' color='primary' onClick={browserHistory.goBack}>{<FormattedMessage id="back" />}</Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar className={classes.avatar}>
                <QueuePlayNext />
              </Avatar>
              <Typography component='h1' variant='h5'>
                {<FormattedMessage id="edit.item" />} <Title />
              </Typography>
              <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='application/json'>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <TextField inputProps={{ maxLength: 250 }} fullWidth label={intl.formatMessage({ id: "title.quickresponse" })} autoComplete='fname' variant='outlined' name='title' onChange={this.handleInputChange} value={item.title} required />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                      <Typography style={{ flexGrow: 1 }}>
                        <FormattedMessage id="content.quickresponse" />
                      </Typography>
                      <AddCommonPlaceholder
                        onChange={(value) => this.handleChangeEditor(value, 'content')}
                        value={item.content}
                        types={[PlaceType.Chat]}
                      />
                    </div>
                    <div style={{ resize: "vertical", overflow: "auto", height: "250px", marginBottom: "24px", border: "1px solid #ccc" }}>
                      <ReactQuill
                        name="content"
                        value={item.content}
                        style={{ height: "100%" }}
                        modules={this.reactQuillModules}
                        formats={this.reactQuillFormats}
                        fullWidth
                        variant="outlined"
                        id="description"
                        onChange={(value) => this.handleChangeEditor(value, "content")}
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <Switch
                      value={item.ismessagehighlight}
                      checked={item.ismessagehighlight}
                      name="ismessagehighlight"
                      onChange={(e) => this.handleChangeSwitch(e)} 
                    />
                    <FormattedMessage id="ismessagehighlight" />
                  </Grid>

                  <Grid item xs={12}>
                    <Grid item xs={12} sm={12}>
                        <section style={{ width: '100%' }}>
                            <div className={classes.dropzoneArea} style={{ minHeight: '70px', marginTop: '5px ' }}>
                                <Dropzone onDrop={acceptedFiles => this.validateImagesAtachments([...this.state.files, ...acceptedFiles])}>
                                    {({ getRootProps, getInputProps }) => (
                                      <div {...getRootProps()}>
                                          <input {...getInputProps()} />
                                          <AttachFileIcon />
                                          <Typography component="span" fontWeight="bold" fontSize={16} color="gray">
                                              <FormattedMessage id="drag.and.drop.logo.45" />
                                          </Typography>
                                      </div>
                                    )}
                                </Dropzone>
                                {this.state.files.map(file => {
                                    return (
                                      <div className={classes.dropzoneItem} key={file?.name} style={{display: 'flex', alignItems: 'center'}}>
                                        {file?.name}
                                        <DeleteForever 
                                          className={classes.deleteItem} 
                                          onClick={() => { this.removeItem(file) }} 
                                        />
                                      </div>
                                    )
                                })}
                            </div>
                        </section>
                    </Grid>
                  </Grid>

                  {this.state.quickResponseAttachments.length > 0 && (
                    <Grid item xs={12} style={{ marginTop: 15 }}>
                      <div className={classes.attachmentsBox}>
                        <label>{<FormattedMessage id="attachments" />}</label>
                        <ImageList cellHeight={100} className={classes2.ImageList} cols={1} >
                          <ul>
                            {this.state.quickResponseAttachments.map(file => {
                              return (
                              <li key={file.attachmentid} style={{display: 'flex', alignItems: 'center'}}>
                                <AttachFile /> 
                                <Button 
                                  onClick={() => this.getFile(file)}
                                >
                                  {file.name}
                                </Button>
                                <Tooltip 
                                  title={<h5>Remover arquivo</h5>}
                                >
                                  <IconButton aria-label="textevidence"
                                    onClick={ () => this.removeLogo(file.attachmentid)}
                                  >
                                    <RemoveIcon />
                                  </IconButton>
                                </Tooltip>
                              </li>)
                            })}
                          </ul>
                        </ImageList>
                      </div>
                    </Grid>
                  )}


                  <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                    <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                      <Grid item xs={12} sm={4}    >
                        <Button
                          type='submit'
                          fullWidth
                          variant='contained'
                          color='primary'
                          className={classes.submit}

                        >
                          {<FormattedMessage id="save" />}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />

            <DialogGeneral
              dialogTitle="Remover"
              dialogSubTitle="Você deseja remover este anexo?"
              open={this.state.DialogRemoveState}
              openOrCloseModalFunction={this.openOrCloseRemoveModal}
              handleConfirmation={this.handleDeleteAttachment}
            />      
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}
QuickResponseEdit.propTypes = {
  classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  quickresponses: state.quickresponses
});
export default injectIntl(connect(mapStateToProps)(withStyles(Styles)(QuickResponseEdit)));
